import React from "react";
import { Link } from "react-router-dom";
import SattlementTable from "./ClearSattlementTable";

function ClearSattlementRequestsPage() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="card card-block card-stretch card-height">
            {" "}
            <div className="card-header d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title mb-0">Clear Sattlement Requests</h4>
              </div>
            </div>
            <SattlementTable />
            {/* <Table /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClearSattlementRequestsPage;
